export default __webpack_public_path__ + "static/media/logo.05fcc4a8.png";